var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"private-history"},[_c('h1',[_vm._v("コメント履歴の閲覧について")]),_vm._v(" "),_c('p',[_vm._v("このページではコメント履歴を表示できません。")]),_vm._v(" "),_c('p',[_vm._v("コメント履歴はご本人のみ閲覧できます。")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Index' }}},[_vm._v("トップページへ戻る")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }